import React from 'react'
import GameCompo from '../components/GameCompo'
import CoreGame from '../components/CoreGame'

const GameInfo = () => {
  return (
    <>
        <GameCompo />
        <CoreGame />
    </>
  )
}

export default GameInfo